import { SurveyListItemDto } from "api/survey";
import { Sizes } from "enums/sizes";
import { usePanel } from "hooks/usePanel";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { SurveyForm } from "./form/SurveyForm";
import { SURVEY_TABLE_PRESETS, GenericSurveysTable } from "./GenericSurveysTable";
import { useSurveyForm } from "./hooks/useSurveyForm";
import { useDialog } from "hooks/useDialog";

export function SurveysTable() {
  const { openPanel } = usePanel();
  const { openDialog, closeDialog, setDialogActions } = useDialog();
  const navigate = useNavigate();
  const { createSurvey, deleteSurvey } = useSurveyForm();

  const openAddSurveyForm = useCallback(() => {
    openPanel({
      title: "Ajouter un questionnaire",
      size: Sizes["4xl"]
    },
      <SurveyForm onSubmit={createSurvey} />
    );
  }, [openPanel, createSurvey]);

  const handleView = useCallback((survey: SurveyListItemDto) => {
    navigate(`/back-office/questionnaires/${survey.id}`);
  }, [navigate]);

  const handleDelete = useCallback((survey: SurveyListItemDto) => {
    openDialog({
      title: "Supprimer le questionnaire",
      size: Sizes["2xl"]
    }, <div>
      {`Êtes-vous sûr de vouloir supprimer le questionnaire "${survey.name}" ? Cette action est irréversible.`}
    </div>);
    setDialogActions({
      onSubmit: async () => {
        await deleteSurvey(survey.id);
        closeDialog();
      },
      submitLabel: "Supprimer",
      closeLabel: "Annuler"
    });
  }, [openDialog, closeDialog, setDialogActions, deleteSurvey]);

  return (
    <GenericSurveysTable
      columnPreset={SURVEY_TABLE_PRESETS.FULL}
      onCreateConfig={{
        label: "Ajouter un questionnaire",
        onClick: openAddSurveyForm
      }}
      onViewClick={handleView}
      onDeleteClick={handleDelete}
    />
  );
}
